import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api.js';
import PageState from '../../components/PageState.jsx';
import BrandingTab from '../company/BrandingTab.jsx';

/**
 * Branding (ENTRAID-340), on Settings > Company since the ENTRAID-347 redesign (plan C6; it was a Company Settings tab):
 * the logo in reports and the header name in emails. Loads the settings view once and replaces it with whatever a save
 * returns.
 *
 * @param {object} props
 * @param {string} props.customerId
 * @param {boolean} props.readOnly an operator who is not this tenant's admin: state only, no controls (also in "View as
 *   client": that switch changes only what the UI shows, the token stays the operator's and the API refuses writes)
 */
export default function CompanyBranding({ customerId, readOnly = false }) {
  const [view, setView] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setError('');
    try {
      setView(await api.companySettings(customerId));
    } catch {
      setError('Branding could not be loaded. Try again in a few minutes.');
    }
  }, [customerId]);

  useEffect(() => { load(); }, [load]);

  if (error) return <PageState state="error" title="Branding could not be loaded" message={error} onRetry={load} />;
  if (!view) return <p className="py-8 text-center text-sm text-ipc-muted" role="status">Loading branding</p>;
  return <BrandingTab customerId={customerId} view={view} readOnly={readOnly} onChange={setView} />;
}
